import React from "react";
import { Translate } from "react-localize-redux";
import {
	AccountInsightsFinancialHistorySection,
	AccountInsightsSessionActivitySection,
	AccountInsightsSummarySection,
} from "./components";
import { PageWrapper } from "./elements";
import useController from "./useController";

const AccountInsightsContent = ({ translate }) => {
	useController();

	return (
		<PageWrapper>
			<AccountInsightsSummarySection translate={translate} />
			<AccountInsightsSessionActivitySection translate={translate} />
			<AccountInsightsFinancialHistorySection translate={translate} />
		</PageWrapper>
	);
};

const AccountInsights = () => (
	<Translate>
		{({ translate }) => <AccountInsightsContent translate={translate} />}
	</Translate>
);

export default AccountInsights;
